<template>
  <div class="ListaSelosCancelados">
    <div class="ListaSelosCancelados_header px-3 py-2">
      <div class="row">
        <div class="col-3">
          Número do selo
        </div>
        <div class="col-3">
          Data do cancelamento
        </div>
      </div>
    </div>
    <div v-for="(selo, index) in propListaSelos"
         :key="index"
         class="ListaSelosCancelados_item py-2 px-3">
      <div class="row">
        <div class="col-3">
          <div class="m-0 p-0 col-12">
            <div>
              {{ selo.num_selo }}
            </div>
            <div v-if="selo.seloItemOs"
                 class="ListaSelosCancelados_item_ato">
              {{ selo.seloItemOs.ordemServicoItem.custa.ato }}
            </div>
            <div v-else
                 class="ListaSelosCancelados_item_ato">
              Sem descrição
            </div>
          </div>
        </div>
        <div v-if="selo.data_cancelamento"
             class="col-3">
          {{ selo.data_cancelamento | date }}
        </div>
        <div v-else
             class="col-3">
          Data não informada
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "ListaSelosCancelados",
    props: {
      propListaSelos: { type: Array, default: () =>([])}
    }
  }
</script>
<style lang="scss">
  .ListaSelosCancelados {
    &_header {
      background: #01bfa5;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
    }

    &_item {
      font-family: Roboto;
      font-size: 16px;
      overflow: hidden;

      &_ato {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

    /**
      &_ato:hover {
      white-space : nowrap;
      overflow: inherit;
      text-overflow: ellipsis;
      }
    */

    }

    &_item:nth-child(even) {
      background: #eaeaea;
    }
    &_item:nth-child(odd) {
      background: #ffffff;
    }
  }

</style>
